"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ts_money_1 = require("ts-money");
var Invoice_1 = __importStar(require("./Invoice"));
var Payment = /** @class */ (function () {
    function Payment(json) {
        this.id = json.id;
        this.branchID = json.branchID;
        if (json.invoices) {
            this.invoices = json.invoices.map(function (invoiceJSON) { return new Invoice_1.default(invoiceJSON); });
        }
        else {
            this.invoices = [];
        }
        this.amount = ts_money_1.Money.fromInteger(json.amount, ts_money_1.Currencies.MYR);
        this.createdAt = new Date(json.createdAt);
        this.paymentMethod = Invoice_1.PaymentMethod.byID(json.paymentMethod);
        this.transactionID = json.transactionID;
        this.notes = json.notes;
        this.paymentAccountID = json.paymentAccountID;
    }
    Object.defineProperty(Payment.prototype, Symbol.toStringTag, {
        get: function () {
            return 'Payment';
        },
        enumerable: false,
        configurable: true
    });
    return Payment;
}());
exports.default = Payment;
